module.exports = __webpack_public_path__ + "static/media/car8.06e0a607.png";